// @flow

// Utility file for the validations run on form in the SignupScreen.

const firstNameValid = (name: ?string) => {
  return !!name ? true : false;
};

const lastNameValid = (lastName: ?string) => {
  return !!lastName ? true : false;
};

const inputTooLong = (input: ?string) => {
  if (input) {
    return input.length >= 255 ? true : false;
  }
};

const emailValid = (email: ?string) => {
  const emailRegex = /[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
  if (email) {
    return emailRegex.test(email) ? true : false;
  }
};

const passwordsMatch = (password: ?string, password2: ?string) => {
  return !!password && password === password2 ? true : false;
};

const roleSelected = (role: ?string) => {
  return !!role ? true : false;
};

const termsTickbox = (terms: ?boolean) => {
  return !!terms ? true : false;
};

export {
  firstNameValid,
  lastNameValid,
  inputTooLong,
  emailValid,
  passwordsMatch,
  roleSelected,
  termsTickbox
};
